import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router';

import {BLOG_URL} from '../../config/urls';
import {useMovePage} from '../../hooks/useMovePage';
import openNewWindow from '../../utils/openNewWindow';
import styles from './styles/footer-item.module.css';

export default function FooterItem({ type, Image, title, contentMap }) {
  const location = useLocation();

  const movePage = useMovePage();

  const [isMainPage, setIsMainPage] = useState(false);

  const clickContent = (content) => {
    if (content === '블로그') openNewWindow(BLOG_URL);
    if (content === '채팅 기능') movePage('/service/chat');
    if (content === '관리자 기능') movePage('/service/admin');
    if (content === 'FAQ') {
      if (location.pathname === '/') {
        document.querySelector('#faq-section')?.scrollIntoView({ behavior: 'smooth' });
      } else {
        movePage('/');
        setIsMainPage(true);
      }
    }
    
    return;
  };

  const activeCursor = (content) => {
    if (content === '채팅 기능' || content === '관리자 기능' || content === '블로그' || content === 'FAQ') return 'active';
    return '';
  }

  useEffect(() => {
    if (isMainPage) {
      setTimeout(() => {
        document.querySelector('#faq-section')?.scrollIntoView({ behavior: 'smooth' });
      }, 150);
      setIsMainPage(false);
    }
  }, [isMainPage]);

  return (
    <div className={styles.wrapper} data-type={type}>
        <div>
            {Image ? <Image /> : null}
            {title ? <p>{title}</p> : null}
        </div>
        <div className={styles.boxContent}>
            {contentMap.map((content, index) => (
                <p 
                  key={index}
                  data-type={activeCursor(content)}
                  onClick={() => clickContent(content)}
                >
                  {content}
                </p>
            ))}
        </div>
    </div>
  );
}
